const getHostEnv = () => {
  const hostname = window.location.hostname;
  let hostEnv = '' as 'dev' | 'staging' | 'prod';

  if (
    hostname.includes('localhost') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('dev')
  ) {
    hostEnv = 'dev';
  } else if (hostname.includes('stag')) {
    hostEnv = 'staging';
  } else {
    hostEnv = 'prod';
  }

  return hostEnv;
};

export const HOST_ENV = getHostEnv();

const getBaseUrl = (protocol = 'https:') => {
  const envBaseUrl = process.env.UMI_APP_API_BASE_URL;

  if (envBaseUrl) return envBaseUrl;

  let baseUrl = '';

  if (HOST_ENV === 'dev') {
    baseUrl = `${protocol}//api-portal-dev.youlify.ai`;
  } else if (HOST_ENV === 'staging') {
    baseUrl = `${protocol}//api-portal-staging.youlify.ai`;
  } else {
    baseUrl = `${protocol}//api-portal.youlify.ai`;
  }

  return baseUrl;
};

export const BASE_HTTPS_URL = getBaseUrl('https:');
